<div *ngIf="appService.theme$ | async as theme">
  <p-menu class="menu-content" [model]="menuItems">
       <ng-template pTemplate="menuItem" let-item>
           <ng-container>
             <a [routerLink]="item.route" class="p-menuItem-link"
               [style]="{'border-left': (item.selected===true) ? 
               '4px solid var(--border-menu-active)' : '4px solid var(--surface-0)',
               'background': (item.selected===true) ? 'var(--surface-100)' : 'var(--surface-0)'}"
               >
               @if (item.label == 'Flights') {
               <img style="width: 17px; height: 17px"
                 [src]="theme == 'light' ? item.iconLight : item.iconDark" />
               }
               @else {
                @if(navSignalsService.badgeCountActive$() && item.label == 'About') {
                  <i [class]="item.icon" style="width: 17px; height: 17px" pBadge severity="danger" ></i>
                }
                @else {
                  <i [class]="item.icon" style="width: 17px; height: 17px"></i>
                }
               }
               <span>{{ item.label }}</span>
             </a>
  
           </ng-container>
       </ng-template>
     </p-menu>
</div>
